<template>
<!--팝업-->
<div class="popup_bg" v-if="modal.open">
    <div class="popup_box">
        <p>{{modal.content}}</p>

        <div class="close_btn_box" v-if="modal.btnTwo">
            <button class="close_btn"
                v-if="modal.btnOne"
                @click="bottonOneSubmit">
                {{modal.btnOne}}
            </button>
            <button class="close_btn"
                v-if="modal.btnTwo"
                @click="bottonTwoSubmit">
                {{modal.btnTwo}}
            </button>
        </div>

        <button class="close_btn" v-else @click="bottonOneSubmit">
            {{modal.btnOne}}
        </button>

    </div>
</div>
<!--팝업-->
</template>

<script>


import { mapState } from 'vuex';
export default {
    name:'ModalBase',
    computed: {
        ...mapState({
            modal: state => state.common.modal,
        }),
    },
    methods: {
        bottonOneSubmit() {
            this.$store.commit('CLOSE_MODAL');
            if(this.modal.btnOneSubmit) 
                this.modal.btnOneSubmit();
        },
        bottonTwoSubmit(){
            this.$store.commit('CLOSE_MODAL');
            if(this.modal.btnTwoSubmit) 
                this.modal.btnTwoSubmit();
        },
    },
}


</script>

<style scoped>

</style>